<template>
  <div>
    <section class="txt-c ds-search-blank" v-if="!loading&&empty===10">
      <p class="pb16"><img src='../../../assets/images/common/blank.png'/></p>
      <p class="f14 c-gray">抱歉，您还没有就业队长~</p>
    </section>
    <!-- <div class="txt-c mt40" v-if="!loading&&empty===10" @click="goShare('leader-invite')">
      <div class="share-pos c-white heartBeat"><span class="f20 pl23">分享专属海报</span></div>
    </div> -->
    <template v-if="list.length">
      <!-- <div class="plr15 img-auto" @click="goShare('leader-invite')">
        <img class="" src="../../../assets/images/staff/tip-img.png"/>
      </div> -->
      <p class="c-gray plr15 txt-r">我的就业队长共 <span class="c-333">{{TotalCount}}</span> 人</p>
      <van-pull-refresh v-model="refreshing" @refresh="getList(true, true)" class="leader-van-pull">
        <van-list v-model="loading" :finished="finished" :immediate-check="false" @load="getList()">
          <div v-for="(item, index) in list" :key="index">
            <section class="staff-box bg-white">
              <div class="enroll-list staff-avatar wld-avatar flex all-c">
                <div class="ds-avatar txt-c mr10">
                  <img src="../../../assets/images/common/user-photo.jpg"
                       v-if="!item.avatarUrl"/>
                  <img :src="item.avatarUrl" v-else/>
                </div>
                <div class="flex-1">
                  <p class="f16 f-b mr5 lb-vm">{{item.name||item.phoneNumber}}</p>
                </div>
                <div class="txt-c phone-bor fr" @click="callTel(item.phoneNumber)">
                  <span class="icon icon-storePhone c-green f20 lb-vm"></span>
                </div>
              </div>
              <div class="box-foot">
                <van-row type="flex" justify="center" class="txt-c">
                  <van-col span="8">
                    <p class="c-gray f12">总人数</p>
                    <p class="f-b f18 mt5">{{item.seekerNum}}</p>
                  </van-col>
                  <van-col span="8">
                    <p class="c-gray f12">在职人数</p>
                    <p class="f-b f18 mt5">{{item.employeeNum}}</p>
                  </van-col>
                  <van-col span="8">
                    <p class="c-gray f12">累计贡献(元)</p>
                    <p class="f-b f18 mt5 c-orange">{{item.TotalAmount}}</p>
                  </van-col>
                </van-row>
              </div>
            </section>
          </div>
        </van-list>
      </van-pull-refresh>
    </template>
  </div>
</template>

<script>
  import api from '../../../api';
  import login from '../../../mixins/login';

  export default {
    mixins: [login],
    data() {
      return {
        empty: 0,
        list: [],
        refreshing: false,
        loading: false,
        finished: false,
        TotalCount: 0,
        Paging: { PageIndex: 1, PageSize: 20 }
      };
    },
    mounted() {
      this.getList(true);
    },
    methods: {
      async getList(init = false, isRefresh = false) {
        try {
          if (init) this.Paging.PageIndex = 1;
          if (isRefresh) this.refreshing = true;
          else this.loading = true;
          
          // POST 请求版本（暂时注释，后续恢复使用）
          /*
          const res = await api.post('/api/vpai/vteam/page_sub', {
            pageNum: this.Paging.PageIndex,
            pageSize: this.Paging.PageSize
          });
          */
          
          // 临时改为 GET 请求
          const res = await api.get('/api/vpai/vteam/page_sub', {
            params: {
              pageNum: this.Paging.PageIndex,
              pageSize: this.Paging.PageSize
            }
          });

          let list = [];
          let total = 0;
          if (res && res.code === 10000) {
            if (Array.isArray(res.data)) {
              list = res.data;
              total = res.data.length;
            } else if (res.data && Array.isArray(res.data.list)) {
              list = res.data.list;
              total = res.data.total || list.length;
            }
          } else if (res && res.List) {
            list = res.List;
            total = (res.Paging && res.Paging.TotalCount) || list.length;
          }

          if (init) this.list = list;
          else this.list = [...this.list, ...list];
          this.TotalCount = total;
          this.$nextTick(() => {
            this.empty = init && total === 0 ? 10 : 0;
            this.finished = true; // 固定一次GET视为加载完
            this.Paging.PageIndex++;
            this.loading = false;
            this.refreshing = false;
          });
        } catch (e) {
          this.loading = false;
          this.finished = true;
          this.refreshing = false;
          this.$error(e.message);
        }
      }
    }
  };
</script>

<style lang="less" scoped>
  @import '../../../assets/css/theme.less';

  .staff-box {
    margin: 5px 15px 10px 15px;
    border-radius: 5px;
    box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.1);
  }

  .staff-avatar {
    padding: 20px;
  }

  .wld-avatar {
    padding: 15px 20px;
  }

  .staff-avatar .ds-avatar {
    width: 44px;
    height: 44px;
  }

  .box-foot {
    border-top: 1px dashed #d2d5d6;
    padding: 15px 20px;
  }

  .share-pos {
    background: url(../../../assets/images/staff/no-btn.png) no-repeat;
    background-size: cover;
    width: 295px;
    height: 73px;
    line-height: 100px;
    margin: 0 auto;
    overflow: hidden;
  }

  @-webkit-keyframes heartBeat {
    0% {
      -webkit-transform: scale(1);
      transform: scale(1)
    }
    14% {
      -webkit-transform: scale(1.1);
      transform: scale(1.1)
    }
    28% {
      -webkit-transform: scale(1);
      transform: scale(1)
    }
    42% {
      -webkit-transform: scale(1.1);
      transform: scale(1.1)
    }
    70% {
      -webkit-transform: scale(1);
      transform: scale(1)
    }
  }

  @keyframes heartBeat {
    0% {
      -webkit-transform: scale(1);
      transform: scale(1)
    }
    14% {
      -webkit-transform: scale(1.1);
      transform: scale(1.1)
    }
    28% {
      -webkit-transform: scale(1);
      transform: scale(1)
    }
    42% {
      -webkit-transform: scale(1.1);
      transform: scale(1.1)
    }
    70% {
      -webkit-transform: scale(1);
      transform: scale(1)
    }
  }

  .heartBeat {
    animation: heartBeat 1.3s infinite ease-in-out;
    -webkit-animation: heartBeat 1.3s infinite ease-in-out;
  }

  .leader-van-pull {
    min-height: calc(100vh - 235px);
  }
</style>

